import { Vocabulary } from "../Vocabulary";
import AppsIcon from "@mui/icons-material/Apps";

export const ROUTER_APPLICATIONS = {
  routes: ["/", "/applications", "*"],
};

export const MAIN_SLIDER_APPLICATIONS = [
  {
    name: Vocabulary.applications,
    path: "/applications",
    icon: <AppsIcon />,
    orderId: 25,
  },
];

export const VEHICLE_OPTIONS_APPLICATIONS = [];
export const DINAMIC_TABS_APPLICATIONS = {};
export const MAIN_TABLE_APPLICATIONS = null;